import classNames from "classnames/bind";
import React from "react";
import PropTypes from "prop-types";
import { Button, Typography, withStyles } from "@theconversation/ui";
import styles from "./styles.scss";

const classNamesMapping = classNames.bind({
  button: styles.button,
  buttonSelected: styles.on,
});

const AmountButton = ({ active, width, selected, label, onClick, children }) => (
  <div style={{ width }} className={styles.container}>
    <Button
      disabled={!active}
      fullWidth
      className={classNamesMapping("button", { buttonSelected: selected })}
      color={selected ? "primary" : "secondary"}
      onClick={onClick}
      variant="contained"
    >
      <Typography className={styles.label} variant="h5">{label}</Typography>
      {children}
    </Button>
  </div>
);

AmountButton.defaultProps = {
  active: true,
  children: undefined,
  label: "",
  onClick: () => {},
  selected: false,
  width: "20%",
};

AmountButton.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  width: PropTypes.string,
};

export default withStyles(styles)(AmountButton);
